import React from "react";
// Customizable Area Start
import { Box } from "@mui/material";
import {logo} from "../../customisableuserprofiles/src/assets"

import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
// Customizable Area End
import DashboardController, {
  Props,
} from "./DashboardController.web";

export default class Dashboard extends DashboardController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  // Customizable Area Start

  // Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', height: '100%', overflowX: 'hidden',  overflowY: 'hidden'}}>
      {/* Sidebar */}
      <Box sx={{ minHeight: '100vh', flexGrow: 0, backgroundColor: '#ffffff', borderRight: '1px solid #cbd5e1', width: '115px', height: '100%', }}>
        <NavigationMenu id={""} navigation={this.props.navigation} />
      </Box>
      {/* Main Content */}
      <Box sx={{ height: '100%', flexGrow: 1, minHeight: '100vh', width: '100%', padding: 2 }}>
          <Box sx={{ margin: '22px', }}>
            <img
              data-test-id="back_arrow"
              onClick={(e) => {
                e.stopPropagation()
                this.props.navigation.navigate("LandingPage")
              }}
              src={logo}
              style={{ height: '24px', width: '148px', cursor: 'pointer' }}
              alt="Logo"
            />
          </Box>
        </Box>
    </Box>
    );
    // Customizable Area End
  }
}

// Customizable Area Start

const webStyles = {
  
};
// Customizable Area End
